import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IMeetingByDatePayloadState } from '@app-store/slices/meetingStatistics/meetingByDate'

interface TaskAction extends Action {
    payload: IMeetingByDatePayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingStatistics.meetingByDate

function* meetingByDateSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/stats/meeting-by-date`)
        if (response.success) {
            yield put(onSuccess(response.result.data))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* meetingByDateSaga(): any {
    yield takeLatest<TaskAction>(onRequest, meetingByDateSagaTask)
}

export default meetingByDateSaga
